import { useEffect, useRef, useState } from "react";
import { API, fmtWaktu, pesanGalat } from "../lib/api";
import Shell from "../components/Shell";
import { JudulHalaman, KerangkaBaris, KeadaanGalat, KELAS_TABEL, KELAS_TH, KELAS_TD } from "../components/kit";
import { Paginasi } from "../components/Paginasi";

export default function Sapuan() {
  const [berkas, setBerkas] = useState(null);
  const [pratinjau, setPratinjau] = useState(null);
  const [sistemId, setSistemId] = useState("");
  const [sistem, setSistem] = useState([]);
  const [hasil, setHasil] = useState(null);
  const [riwayat, setRiwayat] = useState(null);
  const [galat, setGalat] = useState(null);
  const [muat, setMuat] = useState(false);
  const inputRef = useRef(null);
  const barisRef = useRef([]);
  const [teksImpor, setTeksImpor] = useState("");
  const [hasilImpor, setHasilImpor] = useState(null);
  const [imporMuat, setImporMuat] = useState(false);

  const impor = async () => {
    setImporMuat(true);
    try {
      const r = await API.post("/orang/impor", { teks: teksImpor });
      setHasilImpor(r.data);
      setTeksImpor("");
    } catch (err) { alert(pesanGalat(err)); } finally { setImporMuat(false); }
  };

  useEffect(() => {
    API.get("/sistem").then((r) => setSistem(r.data)).catch(() => {});
    muatRiwayat();
  }, []);
  const muatRiwayat = (halaman = 1) => {
    API.get("/sapuan/riwayat", {
      params: { berhalaman: true, halaman, ukuran: 10 },
    }).then((r) => setRiwayat(r.data)).catch(() => {});
  };

  const unggah = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBerkas(f); setPratinjau(null); setHasil(null); setGalat(null); setMuat(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await API.post("/sapuan/pratinjau", fd);
      setPratinjau(r.data);
      const teks = await f.text();
      const garis = teks.split(/\r?\n/).filter(Boolean);
      const kepala = garis[0].split(",").map((h) => h.trim());
      barisRef.current = garis.slice(1).map((g) => {
        const sel = g.split(",");
        const o = {};
        kepala.forEach((h, i) => { o[h] = (sel[i] || "").trim(); });
        return o;
      });
    } catch (err) { setGalat(pesanGalat(err)); } finally { setMuat(false); }
  };

  const jalankan = async () => {
    setMuat(true); setGalat(null);
    try {
      const buang = new Set(pratinjau.kolom_disamarkan);
      const baris = barisRef.current.map((b) => Object.fromEntries(Object.entries(b).filter(([k]) => !buang.has(k))));
      const r = await API.post("/sapuan/jalankan", { sistem_id: sistemId, nama_berkas: berkas.name, baris });
      setHasil(r.data);
      muatRiwayat();
    } catch (err) { setGalat(pesanGalat(err)); } finally { setMuat(false); }
  };

  const unduhTemuan = async () => {
    const r = await API.get("/sapuan/temuan.csv", { responseType: "blob" });
    const u = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = u; a.download = "temuan_sapuan.csv"; a.click();
    URL.revokeObjectURL(u);
  };

  return (
    <Shell>
      <JudulHalaman testid="judul-sapuan" judul="Sapuan"
        sub="Unggah CSV daftar akun dari satu akses. Kolom yang tampak seperti alamat IP atau email otomatis disamarkan." />

      <div className="panel rounded p-5 mb-6" data-testid="area-impor-pegawai">
        <p className="label-kecil">Impor daftar pegawai aktif</p>
        <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
          Tempel daftar pegawai dari HR: satu baris per orang, isi{" "}
          <span className="font-data">kode, nama, departemen, status, tanggal keluar</span>.
          Status ditulis <span className="font-data">aktif</span> atau <span className="font-data">keluar</span>;
          tanggal keluar (misal <span className="font-data">2026-06-01</span>) hanya untuk yang sudah keluar,
          supaya umur akun tak bertuan langsung akurat.
        </p>
        <textarea data-testid="input-impor-pegawai" rows={5} value={teksImpor}
          onChange={(e) => setTeksImpor(e.target.value)}
          placeholder={"K-101, Andini Puspita, Keuangan, aktif\nK-102, Bagas Ramadhan, Operasional, keluar, 2026-06-01"}
          className="mt-4 w-full border rounded px-3 py-2.5 text-sm font-data" />
        <button data-testid="btn-impor-pegawai" disabled={imporMuat || !teksImpor.trim()} onClick={impor}
          className="tombol-utama mt-3 px-4 py-2.5 rounded text-sm disabled:opacity-50">
          {imporMuat ? "Mengimpor…" : "Impor daftar pegawai"}
        </button>
        {hasilImpor && (
          <div className="mt-4 text-sm" data-testid="hasil-impor-pegawai">
            <p className="font-data">
              {hasilImpor.ditambah} orang baru · {hasilImpor.diperbarui} diperbarui · {hasilImpor.dilewati} dilewati
            </p>
            {hasilImpor.galat?.length > 0 && (
              <ul className="mt-2 space-y-1 text-xs text-destructive" data-testid="galat-impor-pegawai">
                {hasilImpor.galat.map((g, i) => <li key={i}>{g}</li>)}
              </ul>
            )}
          </div>
        )}
      </div>

      <div className="border p-4 mb-6 space-y-3" data-testid="area-unggah">
        <label className="text-xs font-medium uppercase tracking-wide" htmlFor="berkas-csv">Berkas CSV</label>
        <input id="berkas-csv" ref={inputRef} data-testid="input-berkas-csv" type="file" accept=".csv" onChange={unggah}
          className="block text-sm" />
        {muat && <KerangkaBaris testid="memuat-pratinjau" n={2} />}
        {galat && <KeadaanGalat testid="galat-sapuan" pesan={galat} onCoba={() => inputRef.current?.click()} />}

        {pratinjau && (
          <div data-testid="pratinjau-kolom" className="space-y-3">
            <p className="text-sm">Ditemukan {pratinjau.jumlah_baris} baris. Berikut kolom yang terbaca:</p>
            <ul className="space-y-1">
              {pratinjau.kolom.map((k) => (
                <li key={k.nama} className="text-sm flex gap-2 items-center" data-testid={`kolom-${k.nama}`}>
                  <span className="font-data">{k.nama}</span>
                  {k.mencurigakan
                    ? <span className="text-xs border border-red-500 text-red-600 dark:text-red-400 px-1.5 py-0.5">disamarkan — {k.alasan}</span>
                    : <span className="text-xs text-muted-foreground">aman</span>}
                </li>
              ))}
            </ul>
            <div className="overflow-x-auto border">
              <table className={KELAS_TABEL}>
                <thead><tr>{pratinjau.kolom.map((k) => <th key={k.nama} className={KELAS_TH}>{k.nama}</th>)}</tr></thead>
                <tbody>
                  {pratinjau.contoh_baris.map((r, i) => (
                    <tr key={i}>{pratinjau.kolom.map((k) => <td key={k.nama} className={`${KELAS_TD} font-data text-xs`}>{r[k.nama]}</td>)}</tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="flex flex-wrap gap-3 items-end">
              <div>
                <label className="text-xs font-medium uppercase tracking-wide" htmlFor="pilih-sistem-sapuan">Akses yang disapu</label>
                <select id="pilih-sistem-sapuan" data-testid="pilih-sistem-sapuan" value={sistemId}
                  onChange={(e) => setSistemId(e.target.value)} className="mt-1 block border bg-background px-2 py-1.5 text-sm">
                  <option value="">— pilih —</option>
                  {sistem.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
                </select>
              </div>
              <button data-testid="btn-jalankan-sapuan" disabled={!sistemId || muat} onClick={jalankan}
                className="px-4 py-2 bg-primary text-primary-foreground text-sm font-medium transition-colors duration-150 hover:opacity-90 disabled:opacity-50">
                Mulai pemeriksaan
              </button>
            </div>
          </div>
        )}

        {hasil && (
          <div className="border p-4" data-testid="hasil-sapuan">
            <p className="font-heading font-semibold">Hasil pemeriksaan: {hasil.nama_berkas}</p>
            <p className="font-data tabular text-sm mt-1">
              {hasil.jumlah_akun} akun · {hasil.jumlah_cocok} cocok · <span className="text-red-600 dark:text-red-400 font-bold">{hasil.jumlah_tak_bertuan} tak bertuan</span>
            </p>
            <button data-testid="btn-unduh-temuan" onClick={unduhTemuan}
              className="mt-3 px-3 py-1.5 border text-sm transition-colors duration-150 hover:bg-secondary">
              Unduh temuan_sapuan.csv
            </button>
          </div>
        )}
      </div>

      <h2 className="font-heading text-lg font-semibold mb-2">Riwayat pemeriksaan</h2>
      {!riwayat ? <KerangkaBaris testid="memuat-riwayat" n={2} /> : riwayat.items.length === 0 ? (
        <p className="text-sm text-muted-foreground italic">belum ada data (n=0)</p>
      ) : (
        <div className="overflow-x-auto border">
          <table className={KELAS_TABEL} data-testid="tabel-riwayat-sapuan">
            <thead>
              <tr>
                <th className={KELAS_TH}>Waktu</th><th className={KELAS_TH}>Akses</th><th className={KELAS_TH}>Berkas</th>
                <th className={KELAS_TH}>Akun</th><th className={KELAS_TH}>Cocok</th><th className={KELAS_TH}>Tak bertuan</th>
              </tr>
            </thead>
            <tbody>
              {riwayat.items.map((r) => (
                <tr key={r.id}>
                  <td className={`${KELAS_TD} font-data text-xs`}>{fmtWaktu(r.waktu)}</td>
                  <td className={KELAS_TD}>{r.sistem_label}</td>
                  <td className={`${KELAS_TD} font-data text-xs`}>{r.nama_berkas}</td>
                  <td className={`${KELAS_TD} font-data`}>{r.jumlah_akun}</td>
                  <td className={`${KELAS_TD} font-data`}>{r.jumlah_cocok}</td>
                  <td className={`${KELAS_TD} font-data text-red-600 dark:text-red-400`}>{r.jumlah_tak_bertuan}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <Paginasi data={riwayat} onHalaman={muatRiwayat} testid="riwayat-sapuan" />
        </div>
      )}
    </Shell>
  );
}
